module.exports = __webpack_public_path__ + "img/icon5.65537d63.png";